module.exports = ( Login, $q, User ) ->

  pleaseRefresh = ' Please try refreshing the page, or contact your account manager if the problem persists.'

  makeForbiddenErrorResponse = (response) ->
    if User?.is_staff
      window.error = "Arachnys staff do not have permission to complete this action."
    else
      Login.redirectToLogin(true)

  makeResponse = (response) ->
    window.error = false
    return $q.when(response.resource)

  makeQueryErrorResponse = (response) ->
    window.error_type = 'error'
    if response.status == 403
      makeForbiddenErrorResponse(response)
    else if response.status >= 400 and response.status <= 500
      window.error = "We're sorry, but we couldn't retrieve the information you were looking for." + pleaseRefresh
    else if response.status == 0
      window.error = "It looks like your internet is down. Please check your connection and try again."
      window.error_type = 'warning'
    else
      window.error = "We're sorry, but the information you were looking for isn't available right now." + pleaseRefresh
    $q.reject(response)

  makeErrorResponse = (response, action) ->
    if response.status == 403
      makeForbiddenErrorResponse(response)
    else
      window.error = "We're sorry, but we couldn't " + action + " this." + pleaseRefresh
    $q.reject(response)

  makeErrorResponseAllowingValidationErrors = (response, action) ->
    if response.status == 400 then $q.reject(response) else makeErrorResponse(response, action)

  return {
    actions: {
      update: {
        method: 'PUT',
        interceptor: {
          responseError: (response) ->
            makeErrorResponse(response, 'update')
        }
      },
      updateAllowingValidationErrors: {
        method: 'PUT',
        interceptor: {
          responseError: (response) ->
            makeErrorResponseAllowingValidationErrors(response, 'update')
        }
      },
      save: {
        method: 'POST',
        interceptor: {
          responseError: (response) ->
            makeErrorResponse(response, 'save')
        }
      },
      delete: {
        method: 'DELETE',
        interceptor: {
          responseError: (response) ->
            makeErrorResponse(response, 'delete')
        }
      },
      get: {
        method: 'GET',
        interceptor: {
          response: (response) ->
            makeResponse(response)
          responseError: (response) ->
            makeQueryErrorResponse(response)
        }
      },
      query: {
        method: 'GET',
        isArray: true,
        interceptor: {
          response: (response) ->
            makeResponse(response)
          responseError: (response) ->
            makeQueryErrorResponse(response)
        }
      },
      queryAllowingErrors: {
        method: 'GET',
        isArray: true,
        interceptor: {
          response: (response) ->
            makeResponse(response)
          responseError: (response) ->
            makeResponse(response)
        }
      }
    },
    byid: {
      id: '@id'
    }
  }
